import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const EditorContainer = styled.div`
  .ql-container {
    font-family: Helvetica Neue, sans-serif;
    font-size: 16px;
    background-color: #fff;
  }

  .ql-editor {
    min-height: 160px;
  }
`;

export const S = {
  ...UIElements,
  EditorContainer,
};
